import { TLang } from '@webtrader/core/i18n';
import request from '@webtrader/core/request';

export enum EMainProductCodeType {
  METATRADER4 = 'METATRADER4',
  FTX = 'FTX',
  METATRADER5 = 'METATRADER5',
  HORIZON = 'HORIZON',
  CENTROID = 'CENTROID',
  GENERIC = 'GENERIC'
}

export enum ESubProductCodeType {
  NEWS = 'NEWS',
  CALENDAR = 'CALENDAR',
  SIGNAL = 'SIGNAL',
  COPY_TRADE = 'COPY_TRADE',
  DEALER = 'DEALER',
  EDUCATION = 'EDUCATION',
  TRADING_VIEW = 'TRADING_VIEW'
}

export enum EMarketTimeManagementType {
  CLIENT = 'CLIENT',
  SERVER = 'SERVER'
}

export enum EFeatureListType {
  ACCOUNT_CLOSURE = 'ACCOUNT_CLOSURE',
  RESET_PASSWORD = 'RESET_PASSWORD',
  CHANGE_PASSWORD = 'CHANGE_PASSWORD',
  CUSTOMER_SERVICE = 'CUSTOMER_SERVICE',
  TOP_GAINER = 'TOP_GAINER',
  TOP_LOSER = 'TOP_LOSER',
  TOP_PICK = 'TOP_PICK',
  PIE_CHART = 'PIE_CHART',
  EXPERIENCE = 'EXPERIENCE',
  FORGOT_PASSWORD = 'FORGOT_PASSWORD'
}

export enum ELoginConfigType {
  COMPANY = 'COMPANY',
  METATRADER4_LIVE = 'METATRADER4_LIVE',
  METATRADER4_DEMO = 'METATRADER4_DEMO',
  METATRADER5_LIVE = 'METATRADER5_LIVE',
  METATRADER5_DEMO = 'METATRADER5_DEMO',
  METATRADER4_METATRADER5_DEMO = 'METATRADER4_METATRADER5_DEMO',
  METATRADER4_METATRADER5_LIVE = 'METATRADER4_METATRADER5_LIVE'
}

export enum EWebtraderResetPasswordType {
  INTEGRATION = 'INTEGRATION',
  REDIRECTION = 'REDIRECTION'
}

export enum ECrmChangePasswordType {
  FORM = 'FORM',
  INTEGRATION = 'INTEGRATION'
}

export enum EProductSubscriptionType {
  FREEMIUM = 'FREEMIUM',
  PREMIUM = 'PREMIUM'
}

export enum ECompanyConfigEnabledFlagListType {
  DEMO_ACCOUNT_CREATION = 'DEMO_ACCOUNT_CREATION',
  ONE_CLICK_TRADING = 'ONE_CLICK_TRADING',
  EDUCATIONAL_VIDEO = 'EDUCATIONAL_VIDEO',
  SIGNAL = 'SIGNAL',
  PRETRADE_DETAILS = 'PRETRADE_DETAILS',
  ESTIMATED_MARGIN_REQUIRED = 'ESTIMATED_MARGIN_REQUIRED',
  TRADING_VIEW = 'TRADING_VIEW'
}

export interface ICompanySubscription {
  productCode: ESubProductCodeType;
  productSubscription: EProductSubscriptionType;
}

export interface ICompany {
  name: string;
  themeColourCode: string;
  profitColourCode: string;
  lossColourCode: string;
  tenantId: string;
  logoPath: string;
  logoDarkThemePath: string;
  faviconPath: string;
  shortcutIconPath: string;
  webtraderMemberTncUrl: string;
  webtraderMemberLogoutUrl: string;
  webtraderMemberPolicyUrl: string;
  webtraderMemberRiskDisclosureUrl: string;
  iosMobileAppUrl: string;
  androidMobileAppUrl: string;
  defaultLanguage: TLang | null;
  supportedLanguages: TLang[] | null;
  marketTime: boolean;
  marketTimeManagement: EMarketTimeManagementType;
  fundManagement: boolean;
  featureList: EFeatureListType[];
  mainProductCodeList: EMainProductCodeType[];
  subProductCodeList: ESubProductCodeType[];
  loginConfigList: ELoginConfigType[];
  email: string;
  mt4DemoRegistrationUrl: string;
  mt4LiveRegistrationUrl: string;
  mt4LiveRegistrationIosUrl: string;
  mt4DemoRegistrationIosUrl: string;
  mt4LiveRegistrationAndroidUrl: string;
  mt4DemoRegistrationAndroidUrl: string;
  mt5LiveRegistrationUrl: string;
  mt5DemoRegistrationUrl: string;
  mt5LiveRegistrationIosUrl: string;
  mt5DemoRegistrationIosUrl: string;
  mt5LiveRegistrationAndroidUrl: string;
  mt5DemoRegistrationAndroidUrl: string;
  companyRegistrationUrl: string;
  crmChangePasswordType: ECrmChangePasswordType;
  crmForgotPasswordType: EWebtraderResetPasswordType;
  crmForgotPasswordUrl: string;
  transactionFee: number;
  serverDlsCorrection: boolean;
  serverTimezone: number;
  tncPath: string;
  oneClickTradingEnabled: boolean;
  demoAccountCreationEnabled: boolean;
  webtraderResetPasswordType: EWebtraderResetPasswordType;
  webtraderResetPasswordUrl: string;
  webtraderContactSupportUrl: string;
  educationalVideoEnabled: boolean;
  companySubscriptionList: ICompanySubscription[];
  signalEnabled: boolean;
  companyConfigEnabledFlagList: ECompanyConfigEnabledFlagListType[];
  multiServerEnabled: boolean;
  otpEnabled: boolean;
  currentMainProductCode: EMainProductCodeType;
}

export const companyAPI = () => request.get<ICompany>('/api/config/v1/company');

// Only for membersite (web/mobileapp) when user is logged in
export const companyUserAPI = () => request.get<ICompany>('/api/config/v1/company/user');
